import { render, staticRenderFns } from "./RefsFleet.vue?vue&type=template&id=f60ad108&scoped=true&"
import script from "./RefsFleet.vue?vue&type=script&lang=ts&"
export * from "./RefsFleet.vue?vue&type=script&lang=ts&"
import style0 from "./RefsFleet.vue?vue&type=style&index=0&id=f60ad108&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60ad108",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
